import { useContext, useState, useEffect } from "react";
// import { Img1, Img1Crop } from "../../../assets/images/img1";
import { DataContext } from "../../../contexts/DataContext";
import {
  StartContainer,
  ImageSvgRes,
  ImageHeader,
} from "../../../styles/Screens/StartStyled";
import { Text, Title } from "../../../styles/Texts";
import { T } from "../../../styles/Theme";
import { Button } from "../../Button";
import axios from "axios";
import { DataSettings } from "../../../interfaces/IStartSettings";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { ADVISER_IDENTIFIER, QUESTIONS_API_URL } from "../../../env";
// import { adviserHasStarted, loadedWelcomeScreen } from "../../../utils/googleAnalytics";
import { AdviserHasOpenedGTM, StartButtonGTM } from "../../../utils/GoogleTagManager";
import { uploadEventRequest } from "../../../utils/requests";

export const StartScreen = () => {
  const [, , screenNumber, setScreenNumber] = useContext(DataContext);

  const sendEvent = () => {
    const code: string = `${ADVISER_IDENTIFIER}[bd36@e00fn47.entel]`;
    const body: any = JSON.stringify({
      data: {eventName: "next", tag: "P0", content: "Quiero comenzar"}
    });
    uploadEventRequest(body, code).then((res) => void(0));
  };

  const handleStart = () => {
    setScreenNumber(screenNumber + 1);
    StartButtonGTM(window);
    sendEvent();

    if (!window.sessionStorage.getItem("tryadviser-started")) {
      // adviserHasStarted();

      window.sessionStorage.setItem("tryadviser-started", "true");
    }
  };

  const [Settings, setSettings] = useState<DataSettings | null>(null);

  useEffect(() => {
    const url = `${QUESTIONS_API_URL}/api/v1/principal-settings/`;
    axios.get(url).then((res) => {
      setSettings(res.data.data);
      // loadedWelcomeScreen()
      AdviserHasOpenedGTM(window)
    });
  }, []);

  return (
    <StartContainer>
      <ImageSvgRes>
        {/* <Img1 className="fullImage" />
        <Img1Crop className="cropImage" /> */}
        <ImageHeader />
      </ImageSvgRes>

      <Title>{Settings ? Settings.welcome_title : <Skeleton />}</Title>
      <Text>{Settings ? Settings.description : <Skeleton count={4} />}</Text>

      <div className="buttonContainer">
        <Button bg={T.blue} c="white" onClick={handleStart}>
          Quiero Comenzar
        </Button>
      </div>
    </StartContainer>
  );
};
